import {FlexRow, Modal, Text} from '@forecast-it/design-system';
import React from 'react';
import {useIntl} from 'react-intl';
import {MODAL_TYPE, showModal} from '../../modals/generic_modal_conductor';
import {ModalProps} from '../../modals/types';

export type ChangeAgentConfirmationModalPayload = {
	onConfirm: () => void;
};

export const showChangeAgentConfirmationModal = (props: ChangeAgentConfirmationModalPayload): void => {
	showModal({
		type: MODAL_TYPE.CHANGE_AGENT_CONFIRMATION_MODAL,
		...props,
	});
};

export const ChangeAgentConfirmationModal = ({
	closeModal,
	onConfirm,
}: ModalProps<ChangeAgentConfirmationModalPayload>): JSX.Element => {
	const {formatMessage} = useIntl();

	const handleConfirm = (): void => {
		onConfirm();
		closeModal();
	};

	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal} closeOnInteractOutside={false}>
			<Modal.Title>{formatMessage({id: 'nova_invocation.change_agent.confirm_title'})}</Modal.Title>
			<Modal.Content>
				<Text>{formatMessage({id: 'nova_invocation.change_agent.confirm_body'})}</Text>
				<FlexRow>
					<Modal.PrimaryFooterButton onPress={handleConfirm} dataCy="change-agent-confirm">
						{formatMessage({id: 'nova_invocation.change_agent.confirm_cta'})}
					</Modal.PrimaryFooterButton>
					<Modal.SecondaryFooterButton onPress={closeModal} dataCy="change-agent-cancel">
						{formatMessage({id: 'nova_invocation.change_agent.keep_conversation'})}
					</Modal.SecondaryFooterButton>
				</FlexRow>
			</Modal.Content>
		</Modal>
	);
};
